import React from 'react';
import { CTAButton } from './CTAButton';
import { HERO_IMAGE, OFFER_ANCHOR } from '../data/electrical';
export function Hero() {
  return <section className="bg-navy px-4 py-4 sm:py-6" data-id="element-84" data-mp="eiblf9qr6a3n">
      <div className="mx-auto max-w-3xl" data-id="element-85" data-mp="9ka4ovgsumvc">
        <h1 className="text-center text-[22px] leading-[1.05] text-white sm:text-4xl" data-id="element-86" data-mp="9lbeyxpzr5c0">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR ELECTRICAL
          PROFESSIONALS
        </h1>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-87" data-mp="128yy08bm5nwj">
          Stop wasting time searching through scattered diagrams, manuals and
          references when you need to diagnose an electrical fault.
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-88" data-mp="nb6llp1d5fmk">
          Get visual diagnostic maps, troubleshooting flows, testing pathways,
          circuit references, measurement guidance and symptom-based resources —
          organized in one professional system.
        </p>

        <a href={OFFER_ANCHOR} className="mt-2 block" data-id="element-89" data-mp="3j6obhix6kkpk">
          <img src={HERO_IMAGE} alt="ELECTRICAL DIAGNOSTIC PRO™ — 6 modules and 4 bonuses shown on desktop, tablet and phone" className="mx-auto w-full max-w-xl" data-id="element-90" data-mp="3o6kdjcmbi22h" />
        </a>

        <CTAButton className="mx-auto mt-1 max-w-md" data-id="element-91" data-mp="3e7l5nw9dmagj">
          ⚡ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
        <p className="mt-1.5 text-center text-[11px] font-semibold text-white/80 sm:text-xs" data-id="element-92" data-mp="30g6lvn7na58f">
          🛡️ 7-Day Money-Back Guarantee{' '}
          <span className="text-volt" data-id="element-93" data-mp="2qkmsp8kgtknd">⚡ COMPLETE 6-IN-1 SYSTEM</span>
        </p>
      </div>
    </section>;
}